import { IGlobalVar } from "../interfaces/global-var.interfaces";
import { OrderType } from "../types/enums";
import { IContext } from "./context.interface";

/**
* Properties that are fixed at construction and must never be reassigned,
* because consumers are allowed to cache them. (e.g. Coupon Service reads 
* developmentMode once and passes it to coupon-ts-lib as ICouponDeps.isDevelopmentMode))
*/
type ImmutableContextKey = 'developmentMode';

export class Context {
    private readonly _tempData: IContext;

    constructor(tempData: IGlobalVar) {
        this._tempData = this._setTempData(tempData);
    }

    private _setTempData(tempData: IGlobalVar): IContext {
        return {
            brandInfo: {
                BrandId: tempData.brandInfo?.BrandId ?? "",
                Name: tempData.brandInfo?.Name ?? "",
                StoreKey: tempData.brandInfo?.StoreKey ?? "",
                GooglePayMerchantId: tempData.googlePayMerchantId,
                GooglePayPublicKey: tempData.googlePayPublicKey
            },
            defaultOrderType: OrderType.DELIVERY,

            languageCode: tempData.languageCode || "en-US",
            publicStorageUrl: tempData.PublicStorageUrl || "",
            brandStoreKey: tempData.storeInfo.StoreKey || "",
            signUpLoyaltyLink: tempData.SignUpLoyaltyLink || undefined,
            singleSignOnToken: tempData.singleSignOnToken || undefined,
            darkMode: false,// tempData.Temp.DarkMode || false,
            locationPermissionDenied: false,
            age: 0,
            developmentMode: tempData.developmentMode,
            isTrack: tempData.isTrack ?? false,
            platform: tempData.platform ?? undefined,
            anchorCategoryId: tempData.anchor || undefined,
            boxTopper: tempData.boxTopper || undefined,
            boxTopperInProgress: false,
            cloudCoupon: tempData.cloudCoupon || undefined,
            cloudCouponInProgress: false,
            couponId: tempData.orderCouponId || undefined,
            qrCode: tempData.qrCode || undefined,
            specialCode: tempData.specialCode || undefined,
            targetStoreKey: tempData.targetStoreKey || undefined,
            heartland: {
                isSet: false,
                token: undefined,
                last4: undefined,
                hps: undefined,
            },
            location: {
                latitude: 0,
                longitude: 0,
                validated: false
            },
            useDataV4: tempData.useDataV4 ?? false,
            useCouponService: tempData.useCouponService ?? [],
            googleMapApiKey: tempData.googleMapApiKey ?? "",
            hereMapApiKey: tempData.hereMapApiKey ?? "",
            hotDealId: tempData.hotDeal || undefined,
            couponRemoveReapplyInProgress: false,
            isOrderHub: !!tempData.orderHubKey,
            orderHubKey: tempData.orderHubKey ?? undefined
            // Temp.loyaltyPointCoupons??
        };
    }

    public getProperty<K extends keyof IContext>(property: K): IContext[K] {
        return this._tempData[property];
    }

    public setProperty<K extends Exclude<keyof IContext, ImmutableContextKey>>(key: K, value: IContext[K]) {
        this._tempData[key] = value;
    }
}